
import Vue from 'vue';
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import LocationDetails from '../components/location-details.vue';
import LocationsList from '../components/locations-list.vue';

declare const Alkami: any;

export default Vue.extend({
  name: 'locations-desktop',
  components: {
    LocationsList,
    LocationDetails
  },
  data() {
    return {
      Alkami
    };
  },
  computed: {
    ...mapState(['Locations']),
    ...mapGetters(['getWidgetTitle'])
  },
  watch: {
    Locations() {
      this.updateGMapAsync('desktop');
    }
  },
  methods: {
    ...mapMutations([
      'setIsLoading',
      'setHasError'
    ]),
    ...mapActions([
      'getLocationSearchTypesAsync',
      'initGMapComponentsAsync',
      'updateGMapAsync',
      'getWidgetTitleAsync'
    ])
  },
  async mounted() {
    this.setIsLoading(true);
    try {
      await this.getLocationSearchTypesAsync();
      await this.initGMapComponentsAsync('desktop');
      await this.getWidgetTitleAsync();
      document.addEventListener('widgetHeaderInitAfter', (event: any) => {
          event.detail.header.title = this.getWidgetTitle ?? 'Locations';
      });
    } catch (e) {
      console.log(e);
      this.setHasError(true);
    }
    this.setIsLoading(false);
  }
});
